function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "facebook",
  d: "M121.344,1.689h1.267a.211.211,0,0,0,.211-.211V.211A.211.211,0,0,0,122.611,0h-1.267a2.325,2.325,0,0,0-2.322,2.322V3.8h-1.478a.211.211,0,0,0-.211.211V5.278a.211.211,0,0,0,.211.211h1.478V9.923a.211.211,0,0,0,.211.211H120.5a.211.211,0,0,0,.211-.211V5.489h1.478a.211.211,0,0,0,.2-.144l.422-1.267a.211.211,0,0,0-.2-.278h-1.9V2.322A.633.633,0,0,1,121.344,1.689Z",
  transform: "translate(-117.333)",
  fill: "#1e58de"
});

var SvgFacebook = function SvgFacebook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5.489,
    height: 10.134,
    viewBox: "0 0 5.489 10.134",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFacebook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/facebook.49057a34.svg";
export { ForwardRef as ReactComponent };